export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Placement',
      description: 'We evaluate your store layout and place a curated selection of snack products that fit your customers. Initial quantities are kept small so we can quickly see what sells.'
    },
    {
      number: '02',
      title: 'Weekly Restock',
      description: 'Our route visits your store weekly to restock products, rotate inventory, and keep shelves full.'
    },
    {
      number: '03',
      title: 'Scale What Moves',
      description: 'We track what sells and expand successful products while replacing slow movers.'
    },
    {
      number: '04',
      title: 'Buy Back',
      description: 'If a product underperforms, we buy it back so your store never gets stuck with inventory that doesn\'t sell.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A simple, hands‑off way for independent stores to offer better snacks without managing inventory.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-10">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-6xl font-bold text-gray-200 mb-4">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {step.description}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-6 w-12 h-0.5 bg-gray-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}